import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import PlayStoreButton from "@/components/PlayStoreButton";

const FinalCTA = () => {
  const { t } = useLanguage();
  return (
    <section
      data-testid="final-cta-section"
      className="relative py-20 sm:py-24"
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8 lg:px-10">
        <div className="relative rounded-[28px] overflow-hidden bg-blue-950 text-white p-10 sm:p-14 lg:p-20">
          <div className="grain" />
          <div className="absolute -top-32 -right-20 w-[420px] h-[420px] rounded-full bg-amber-500/15 blur-3xl" />
          <div className="absolute -bottom-32 -left-20 w-[420px] h-[420px] rounded-full bg-red-700/15 blur-3xl" />

          <div className="relative max-w-3xl">
            <span className="inline-block text-xs font-bold tracking-[0.22em] uppercase text-amber-400">
              {t.finalCta.eyebrow}
            </span>
            <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.05]">
              {t.finalCta.title}
            </h2>
            <p className="mt-5 text-base sm:text-lg text-slate-300 leading-relaxed max-w-2xl">
              {t.finalCta.subtitle}
            </p>

            <div className="mt-9 flex flex-col sm:flex-row items-start sm:items-center gap-5">
              <PlayStoreButton
                size="xl"
                testId="final-cta-playstore"
                variant="light"
              />
              <div className="flex items-center gap-3 text-sm text-slate-300">
                <div className="h-10 w-10 rounded-full bg-amber-500 text-slate-900 inline-flex items-center justify-center font-extrabold">
                  7
                </div>
                <span className="leading-tight">
                  Days free trial
                  <br />
                  <span className="text-xs text-slate-400">
                    Then ₹250/month per exam. Cancel anytime.
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
